import ReactDOM from 'react-dom'

import theme from '@packages/theme'

type ReactPortalProps = {
  children: React.ReactNode
  containerId: string
}

export const ReactPortal = ({ children, containerId }: ReactPortalProps) => {
  let container = document.getElementById(containerId)

  if (!container) {
    container = document.createElement('div')
    container.setAttribute('id', containerId)
    container.setAttribute('class', theme)
    document.body.appendChild(container)
  }

  return ReactDOM.createPortal(children, container)
}
